import { Controller } from '@hotwired/stimulus';

/**
 * Fires a GTM dataLayer event when global search returns zero rows (same surface as resource_search_controller search event).
 */
export default class extends Controller {
  static values = {
    term: String,
    userId: String
  }

  connect() {
    const term = (this.termValue || '').trim();
    if (!term || typeof window.dataLayer === 'undefined') {
      return;
    }

    const userIdFromMeta = document.querySelector('meta[name="ga-user-id"]')?.getAttribute('content');
    const userId = (this.userIdValue && this.userIdValue.length > 0)
      ? this.userIdValue
      : (userIdFromMeta || undefined);

    window.dataLayer.push({
      event: 'search_no_results',
      search_term: term,
      results_count: 0,
      search_type: 'global',
      user_id: userId || undefined,
      search_occurred_at: new Date().toISOString()
    });
  }
}
